/* Member points products: Swiper 4.5, one column per step on both devices. */
(function () {
  'use strict';
  if (customElements.get('memnew-points-products')) return;

  // This reads a separate calculation copy. Merchant-facing HTML is never rewritten.
  function numericPrice(node) {
    if (!node) return null;
    var value = node.textContent.trim().replace(/[\s\u00a0\u202f]/g, '');
    value = value.replace(/^(?:€|\$|£|EUR|USD|GBP)/i, '').replace(/(?:€|\$|£|EUR|USD|GBP)$/i, '');
    if (!/^\d+(?:[.,]\d+)*$/.test(value)) return null;
    var dot = value.lastIndexOf('.');
    var comma = value.lastIndexOf(',');
    if (dot !== -1 && comma !== -1) {
      var decimal = dot > comma ? '.' : ',';
      var thousands = decimal === '.' ? ',' : '.';
      var pieces = value.split(decimal);
      if (pieces.length !== 2 || !/^\d{1,2}$/.test(pieces[1])) return null;
      var groups = pieces[0].split(thousands);
      if (!/^\d{1,3}$/.test(groups[0]) || groups.slice(1).some(function (group) { return !/^\d{3}$/.test(group); })) return null;
      value = groups.join('') + '.' + pieces[1];
    } else if (dot !== -1 || comma !== -1) {
      var parts = value.split(dot !== -1 ? '.' : ',');
      if (parts.length === 2 && /^\d{1,2}$/.test(parts[1])) {
        value = parts.join('.');
      } else if (/^\d{1,3}$/.test(parts[0]) && parts.slice(1).every(function (part) { return /^\d{3}$/.test(part); })) {
        value = parts.join('');
      } else {
        return null;
      }
    }
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function productPrice(card, key) {
    var value = card.getAttribute(key);
    return value !== null && value !== '' && Number.isFinite(Number(value)) ? Number(value) / 100 : null;
  }

  class MemnewPointsProducts extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.cleanups = [];
      this.unitProbe = document.createElement('span');
      this.unitProbe.className = 'memnew-points_c-unit-probe';
      this.unitProbe.setAttribute('aria-hidden', 'true');
      this.appendChild(this.unitProbe);
      this.unitValue = this.unit();
      this.panels = Array.from(this.querySelectorAll('[data-memnew-panel]')).map(function (element) {
        return {
          element: element,
          viewport: element.querySelector('[data-memnew-products]'),
          track: element.querySelector('[data-memnew-track]'),
          cards: Array.from(element.querySelectorAll('[data-memnew-card]')).sort(function (a, b) { return Number(a.dataset.cardPosition) - Number(b.dataset.cardPosition); }),
          columns: [],
          swiper: null
        };
      });
      this.mobile = window.matchMedia('(max-width: 850px)').matches;
      this.prepareCards();
      this.listen(this, 'click', this.onClick.bind(this));
      this.listen(this, 'keydown', this.onKeydown.bind(this));
      this.listen(this, 'load', this.scheduleLayout.bind(this), true);
      this.listen(this, 'pdpn:countdown:complete', this.scheduleLayout.bind(this));
      this.listen(document, 'shopify:block:select', this.onBlockSelect.bind(this));
      this.listen(window, 'resize', this.onResize.bind(this));
      this.listen(document, 'shopify:section:unload', this.onSectionUnload.bind(this));
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(this.onResize.bind(this));
        this.observer.observe(this.querySelector('.memnew-points_c-container'));
      }
      if (document.fonts) document.fonts.ready.then(() => { if (this.started) this.refresh(); });
      this.waitForSwiper();
    }

    listen(target, event, handler, capture) {
      target.addEventListener(event, handler, capture);
      this.cleanups.push(function () { target.removeEventListener(event, handler, capture); });
    }

    waitForSwiper() {
      if (!this.started) return;
      if (!window.Swiper) {
        this.retry = window.setTimeout(this.waitForSwiper.bind(this), 100);
        return;
      }
      this.initTabs();
      this.panels.forEach(this.buildColumns.bind(this));
      this.refresh();
    }

    prepareCards() {
      this.panels.forEach((panel) => panel.cards.forEach((card) => {
        var label = card.querySelector('[data-memnew-auto-discount]');
        if (label) {
          var current = numericPrice(card.querySelector('[data-memnew-custom-price]'));
          var original = numericPrice(card.querySelector('[data-memnew-custom-compare]'));
          if (current === null) current = productPrice(card, 'data-product-price');
          if (original === null) original = productPrice(card, 'data-product-compare');
          if (current !== null && original !== null && original > 0 && current >= 0 && current < original) {
            label.textContent = '-' + Math.round((original - current) / original * 100) + '%';
            label.hidden = false;
          }
        }
        var timer = card.querySelector('[data-pdpn-countdown]');
        if (timer) {
          var end = timer.getAttribute('data-end-at');
          var valid = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(end) && timer.getAttribute('data-state') !== 'invalid';
          if (!valid) {
            card.querySelector('[data-memnew-countdown-copy]').hidden = true;
            var warning = card.querySelector('[data-memnew-time-warning]');
            if (warning) warning.hidden = false;
          } else if (window.__pdpnCountdownRuntime) {
            // Theme Editor may insert HTML after the initial inline scripts have run.
            window.__pdpnCountdownRuntime.registerRoot(timer, this.dataset.sectionId);
          }
        }
      }));
    }

    initTabs() {
      var viewport = this.querySelector('[data-memnew-tabs]');
      if (!viewport) return;
      this.tabSwiper = new Swiper(viewport, {
        slidesPerView: 'auto',
        spaceBetween: this.tabGap(),
        freeMode: true,
        freeModeSticky: false,
        centerInsufficientSlides: true,
        grabCursor: true,
        watchOverflow: true,
        simulateTouch: true,
        loop: false,
        a11y: false,
        // Swiper 4.5 turns a fast release after a 1px pointer move into a short
        // swipe, which both moves the track and cancels the button click.
        // Keep buttons and links out of the drag flow.
        noSwiping: true,
        noSwipingSelector: 'a, button'
      });
    }

    unit() {
      // Resolve inherited CSS calc() values; measuring 100 units reduces pixel rounding.
      var width = parseFloat(window.getComputedStyle(this.unitProbe).width);
      return Number.isFinite(width) && width > 0 ? width / 100 : 0;
    }

    tabGap() { return (this.mobile ? 16 : 61.71) * this.unitValue; }
    cardGap() { return (this.mobile ? 14 : 31.304) * this.unitValue; }

    buildColumns(panel) {
      if (panel.swiper) { panel.swiper.destroy(true, true); panel.swiper = null; }
      var groups = [];
      if (!this.mobile || panel.cards.length <= 2) {
        groups = panel.cards.map(function (card) { return [card]; });
      } else {
        // Each group of four is row-major: 1,2 / 3,4. A trailing pair is one column.
        for (var index = 0; index < panel.cards.length; index += 4) {
          var batch = panel.cards.slice(index, index + 4);
          if (batch.length <= 2) groups.push(batch);
          else {
            groups.push([batch[0], batch[2]]);
            groups.push(batch.length === 4 ? [batch[1], batch[3]] : [batch[1]]);
          }
        }
      }
      var fragment = document.createDocumentFragment();
      panel.columns = groups.map(function (cards) {
        var column = document.createElement('div');
        column.className = 'swiper-slide memnew-points_c-column';
        cards.forEach(function (card, row) {
          card.dataset.memnewRow = row;
          card.querySelectorAll('[data-memnew-zone]').forEach(function (zone) { zone.style.minHeight = ''; });
          card.style.minHeight = '';
          column.appendChild(card);
        });
        fragment.appendChild(column);
        return column;
      });
      panel.track.replaceChildren(fragment);
    }

    initProducts(panel) {
      if (panel.swiper || panel.element.hidden || !panel.columns.length) return;
      var self = this;
      function synchronize() { self.scheduleLayout(); self.syncNavigation(panel); }
      panel.swiper = new Swiper(panel.viewport, {
        slidesPerView: this.mobile ? 2 : 4,
        slidesPerGroup: 1,
        spaceBetween: this.cardGap(),
        grabCursor: true,
        watchOverflow: true,
        simulateTouch: true,
        loop: false,
        a11y: false,
        // A pointer drift of a single pixel already puts Swiper 4.5 into drag
        // mode, and a release within 300ms then counts as a short swipe, so
        // tapping Redeem could turn the page and cancel the link click. Links
        // and buttons never start a drag, so those taps stay plain clicks.
        // No threshold here: a single large drag event must still page.
        noSwiping: true,
        noSwipingSelector: 'a, button',
        on: {
          init: synchronize,
          slideChange: synchronize,
          transitionEnd: synchronize,
          sliderMove: synchronize,
          reachBeginning: synchronize,
          reachEnd: synchronize,
          toEdge: synchronize,
          fromEdge: synchronize,
          resize: synchronize
        }
      });
      panel.element.dataset.memnewReady = 'true';
    }

    syncNavigation(panel) {
      var swiper = panel.swiper;
      if (!swiper || swiper.destroyed) return;
      var viewport = panel.viewport.getBoundingClientRect();
      var last = panel.columns[panel.columns.length - 1].getBoundingClientRect();
      var first = panel.columns[0].getBoundingClientRect();
      var capacity = this.mobile ? 2 : 4;
      var locked = panel.columns.length <= capacity || swiper.isLocked || swiper.snapGrid.length <= 1;
      // Pixel tolerance and the actual final column guard Swiper 4.5's strict progress >= 1.
      var translate = swiper.getTranslate();
      var atStart = Math.abs(translate - swiper.minTranslate()) <= 1 || first.left >= viewport.left - 1;
      var atEnd = Math.abs(translate - swiper.maxTranslate()) <= 1 || last.right <= viewport.right + 1;
      var prev = panel.element.querySelector('[data-memnew-prev]');
      var next = panel.element.querySelector('[data-memnew-next]');
      prev.disabled = locked || atStart;
      next.disabled = locked || atEnd;
      prev.setAttribute('aria-disabled', String(prev.disabled));
      next.setAttribute('aria-disabled', String(next.disabled));
    }

    scheduleLayout() {
      if (!this.started || this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.panels.forEach((panel) => {
          if (!panel.element.hidden && panel.swiper) {
            this.equalize(panel);
            this.syncNavigation(panel);
          }
        });
      });
    }

    equalize(panel) {
      var groups;
      if (!this.mobile) groups = [panel.cards];
      else {
        var start = Math.min(panel.swiper.activeIndex, Math.max(0, panel.columns.length - 2));
        var visible = panel.columns.slice(start, start + 2);
        groups = [0, 1].map(function (row) {
          return visible.map(function (column) { return column.children[row]; }).filter(Boolean);
        });
      }
      // Read inner natural heights first, then write; previous min-heights never feed back.
      var measurements = groups.map(function (cards) {
        return { cards: cards, heights: ['title', 'price', 'countdown', 'button'].map(function (name) {
          return Math.max(0, ...cards.map(function (card) {
            return card.querySelector('[data-memnew-zone="' + name + '"] [data-memnew-zone-inner]').getBoundingClientRect().height;
          }));
        }) };
      });
      panel.cards.forEach(function (card) {
        card.style.minHeight = '';
        card.querySelectorAll('[data-memnew-zone]').forEach(function (zone) { zone.style.minHeight = ''; });
      });
      measurements.forEach(function (group) {
        group.cards.forEach(function (card) {
          card.querySelectorAll('[data-memnew-zone]').forEach(function (zone, index) { zone.style.minHeight = group.heights[index] + 'px'; });
        });
      });
    }

    refresh() {
      if (!this.started || !window.Swiper) return;
      this.unitValue = this.unit();
      if (this.tabSwiper) {
        this.tabSwiper.params.spaceBetween = this.tabGap();
        this.tabSwiper.update();
      }
      this.panels.forEach((panel) => {
        this.initProducts(panel);
        if (panel.swiper && !panel.element.hidden) {
          panel.swiper.params.spaceBetween = this.cardGap();
          panel.swiper.update();
        }
      });
      this.scheduleLayout();
    }

    onResize() {
      if (!this.started) return;
      cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = requestAnimationFrame(() => {
        this.resizeFrame = null;
        var mobile = window.matchMedia('(max-width: 850px)').matches;
        if (mobile !== this.mobile && window.Swiper) {
          this.mobile = mobile;
          this.panels.forEach(this.buildColumns.bind(this));
        }
        this.refresh();
      });
    }

    activate(key, reset) {
      this.querySelectorAll('[data-memnew-tab]').forEach(function (tab) {
        var active = tab.dataset.memnewTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(function (panel) { panel.element.hidden = panel.element.dataset.memnewPanel !== key; });
      this.refresh();
      var panel = this.panels.find(function (item) { return item.element.dataset.memnewPanel === key; });
      if (reset && panel && panel.swiper) panel.swiper.slideTo(0, 0);
    }

    onClick(event) {
      var tab = event.target.closest('[data-memnew-tab]');
      if (tab) { this.activate(tab.dataset.memnewTab, true); return; }
      var button = event.target.closest('[data-memnew-prev], [data-memnew-next]');
      if (!button || button.disabled) return;
      var panel = this.panels.find(function (item) { return item.element.contains(button); });
      if (!panel || !panel.swiper) return;
      if (button.hasAttribute('data-memnew-prev')) panel.swiper.slidePrev();
      else panel.swiper.slideNext();
      this.scheduleLayout();
    }

    onKeydown(event) {
      var tab = event.target.closest('[data-memnew-tab]');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      var tabs = Array.from(this.querySelectorAll('[data-memnew-tab]'));
      var index = tabs.indexOf(tab);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      tabs[index].focus();
      this.activate(tabs[index].dataset.memnewTab, true);
      if (this.tabSwiper) this.tabSwiper.slideTo(index);
    }

    onBlockSelect(event) {
      if (!event.detail || !event.detail.blockId) return;
      var panel = this.panels.find(function (item) { return item.cards.some(function (card) { return card.dataset.blockId === event.detail.blockId; }); });
      if (!panel) return;
      this.activate(panel.element.dataset.memnewPanel, false);
      var index = panel.columns.findIndex(function (column) { return Array.from(column.children).some(function (card) { return card.dataset.blockId === event.detail.blockId; }); });
      if (panel.swiper) panel.swiper.slideTo(index, 0);
      this.scheduleLayout();
    }

    onSectionUnload(event) {
      if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.disconnectedCallback();
    }

    disconnectedCallback() {
      if (!this.started) return;
      this.started = false;
      clearTimeout(this.retry);
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.resizeFrame);
      this.frame = null;
      if (this.observer) this.observer.disconnect();
      this.unitProbe.remove();
      this.unitProbe = null;
      this.unitValue = 0;
      this.cleanups.forEach(function (cleanup) { cleanup(); });
      if (this.tabSwiper) this.tabSwiper.destroy(true, true);
      this.tabSwiper = null;
      this.panels.forEach(function (panel) { if (panel.swiper) panel.swiper.destroy(true, true); });
    }
  }

  customElements.define('memnew-points-products', MemnewPointsProducts);
})();
